import React from "react";

function NPRLogo(props) {
  return (
    <svg
      id="prefix__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 508.2 166.1"
      xmlSpace="preserve"
      {...props}
    >
      <style>{".prefix__st3{fill:#fff}"}</style>
      <path d="M169.8 166.1V0H0v166.1h169.8z" fill="#d62021" />
      <path d="M340.4 166.1V0H169.8v166.1h170.6z" fill="#000005" />
      <path d="M508.2 166.1V0H340.4v166.1h167.8z" fill="#237bbd" />
      <path
        className="prefix__st3"
        d="M135.7 151.4v-50.3c0-7.4-1.4-12.8-4.3-16.3s-7.5-5.1-14-5.1c-3.4.1-6.6 1-9.6 2.5-3.1 1.4-5.9 3.6-8 6.3v63H79.5V64h14.7l3.8 8.2c5.5-6.4 13.7-9.6 24.6-9.6 10.4 0 18.6 3.1 24.6 9.3s9 14.9 9 26v53.6l-20.5-.1zM286.5 153.1c13.3 0 23.9-3.9 31.6-11.6s11.6-18.7 11.6-33c0-30.7-13.9-46-41.8-46-7-.2-13.8 2.4-18.8 7.3V64h-20.4v110.6H269v-25.3c5.5 2.6 11.5 3.9 17.5 3.8zM282 79.9c9.4 0 16.1 2.1 20.2 6.3s6.1 11.5 6.1 21.8c0 9.7-2.1 16.7-6.1 21.2-4.1 4.5-10.8 6.7-20.2 6.7-4.7.1-9.3-1.5-12.9-4.5V85.6c3.3-3.6 8-5.6 12.9-5.7zM481.3 83.1c-3.6-2.3-7.7-3.5-11.9-3.4-4.7 0-8.9 2.1-12.5 6.4-3.7 4.4-5.7 10-5.5 15.7v49.6H431V64h20.4v8.4c5.7-6.5 13.2-9.8 22.7-9.8 6.9 0 12.2 1.1 15.9 3.2l-8.7 17.3z"
        transform="translate(-33.03 -23.33)"
      />
    </svg>
  );
}

export default NPRLogo;
